/** Sensitive file-browser fields encrypted the same way as cloud WebSocket file browser responses. */
export const SHORTCUT_FILE_BROWSER_E2EE_FIELDS = [
  'entries',
  'content',
  'totalLines',
  'size',
  'lineOffset',
] as const;
